export function formatMoney(n: number | null | undefined, currency = "USD"): string {
  if (n == null) return "—";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    notation: "compact",
    maximumFractionDigits: 1,
  }).format(n);
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  return Number.isNaN(d.getTime())
    ? "—"
    : d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
}

export function relativeDays(days: number): string {
  if (days <= 0) return "today";
  if (days === 1) return "1 day";
  return `${days} days`;
}

/** Stalled threshold (mirrors the server's STALL_DAYS) — > this many days with no activity. */
export const STALL_DAYS = 14;

/** Whole days between an ISO date and now (0 if missing/invalid). */
export function daysSince(iso: string | null | undefined): number {
  if (!iso) return 0;
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return 0;
  return Math.floor((Date.now() - t) / 86_400_000);
}

export type SalaryTone = "success" | "warning" | "destructive" | null;

/** Green within band, amber within ~10% of the ceiling, red over (PRD §5.2). */
export function salaryTone(expectation: number | null, _min: number | null, max: number | null): SalaryTone {
  if (expectation == null || max == null) return null;
  if (expectation > max) return "destructive";
  if (expectation > max * 0.9) return "warning";
  return "success";
}
